var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-sheet-polling"},[_c('ui-loading',{staticClass:"bottom-sheet-polling__spinner",attrs:{"inline":""}}),_c('div',{staticClass:"bottom-sheet-polling__text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }